<script setup lang="ts">
export interface Props {
    withBorder?: boolean
    roundedTop?: boolean
    roundedBottom?: boolean
}

withDefaults(defineProps<Props>(), {
    withBorder: false,
    roundedTop: false,
    roundedBottom: false
})
const isAnswerVisible = ref(false)

const toggleAnswer = () => {
    isAnswerVisible.value = !isAnswerVisible.value
}
</script>

<template>
    <div
        class="faq-item"
        :class="[
            withBorder && 'border-b-1 border-zinc-200',
            roundedTop && 'rounded-t-2xl pt-8',
            roundedBottom && 'rounded-b-2xl pb-8'
        ]"
    >
        <div class="question-container" @click="toggleAnswer">
            <h3 :class="isAnswerVisible && 'text-sky-500'">
                <slot name="question" />
            </h3>
            <IconChevronDown
                :class="isAnswerVisible && 'text-sky-500 rotate-180'"
            />
        </div>
        <div
            class="answer-container"
            :class="isAnswerVisible ? 'block' : 'hidden'"
        >
            <slot name="answer" />
        </div>
    </div>
</template>

<style lang="scss" scoped>
.faq-item {
    @apply bg-white md:bg-sky-100 w-full md:w-3/5 pt-6 pb-4 px-4 md:py-4 flex flex-col gap-4;

    .question-container {
        @apply flex justify-between cursor-pointer gap-2;

        svg,
        h3 {
            @apply text-zinc-800;
        }

        &:hover * {
            @apply text-sky-500;
        }

        h3 {
            @apply text-left text-xl md:text-2xl font-bold leading-tight md:leading-loose;
        }
        svg {
            @apply size-full max-w-[24px] md:mt-2;
        }
    }

    .answer-container {
        @apply transition-transform duration-300 transform-gpu pr-6 md:pr-0;
    }
}
</style>
